import React from 'react';

// Organic Pattern SVG
const OrganicPattern = () => (
  <svg className="absolute inset-0 w-full h-full opacity-10" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <pattern id="organic" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
        <path
          d="M50 10C60 10 70 20 70 30C70 40 60 50 50 50C40 50 30 40 30 30C30 20 40 10 50 10Z"
          stroke="white"
          strokeWidth="0.5"
          fill="none"
        />
        <path
          d="M50 50C60 50 70 60 70 70C70 80 60 90 50 90C40 90 30 80 30 70C30 60 40 50 50 50Z"
          stroke="white"
          strokeWidth="0.5"
          fill="none"
        />
        <circle cx="50" cy="30" r="2" fill="white" fillOpacity="0.2" />
        <circle cx="50" cy="70" r="2" fill="white" fillOpacity="0.2" />
      </pattern>
    </defs>
    <rect width="100%" height="100%" fill="url(#organic)" />
  </svg>
);

export default OrganicPattern;